import { useEffect } from 'react';

import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useMst } from '../../../models/rootModel';
import { useAnalytics } from '../../../utils/analytics';
import { calculateAmountWithDiscount } from '../../../utils/price/price.utils';
import { PaymentCompleted } from '../../common/PaymentCompleted/PaymentCompleted';
import { BaseStepV3 } from '../../common/v3/BaseStepV3';
import { DEFAULT_MONTHLY_PLAN_KEY } from '../PaymentStep/PaymentPage';
import { planDataExtractor } from '../PaymentStep/planDataExtractor';
import { GoToAppStepProps } from './GoToAppStep.types';

export const GoToAppStep = observer((props: GoToAppStepProps) => {
  const { isActive, includePaymentConfirmationActions, stepName } = props;
  const { UserPayment, UserDiscoveryResponse } = useMst();
  const analytics = useAnalytics();

  const discount = toJS(UserPayment.discount);

  const currentPlan = planDataExtractor(
    UserPayment.stripePlans[UserPayment.chosenPlanPosition || DEFAULT_MONTHLY_PLAN_KEY]
  );

  useEffect(() => {
    if (isActive) {
      if (includePaymentConfirmationActions) {
        analytics.track('view payment confirmation', {
          productSku: currentPlan.sanitizedId,
          price: calculateAmountWithDiscount(currentPlan.sanitizedAmount, discount),
          planPrice: currentPlan.sanitizedAmount,
          purchaseId: UserPayment.purchaseId,
          paymentType: UserPayment.choosenPaymentMethod,
          stepName,
          segment: UserDiscoveryResponse.segment,
        });
      }
      analytics.track('view go to app step');

      window.scrollTo(0, 0);
    }
  }, [
    isActive,
    analytics,
    currentPlan.sanitizedAmount,
    currentPlan.sanitizedId,
    currentPlan.sanitizedCurrency,
    UserPayment.subscriptionId,
    UserPayment.purchaseId,
    UserPayment.choosenPaymentMethod,
    discount,
    includePaymentConfirmationActions,
    UserDiscoveryResponse.segment,
    stepName,
  ]);

  return (
    <BaseStepV3 {...props} addSpacingNeededForMobileButton={false}>
      <PaymentCompleted />
    </BaseStepV3>
  );
});
